import { render, staticRenderFns } from "./ItemComponent.vue?vue&type=template&id=25e38903&"
import script from "./ItemComponent.vue?vue&type=script&lang=js&"
export * from "./ItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports